import { useQuery, useMutation } from '@tanstack/react-query';

const apiUrl = process.env.REACT_APP_API_URL;

export const fetchAllBlogs = async () => {
  const response = await fetch(`${apiUrl}/GET/blog`);
  if (!response.ok) {
    throw new Error('Error fetching blogs');
  }
  return response.json();
};

export const fetchBlogById = async id => {
  const response = await fetch(`${apiUrl}/GET/blog/${id}`);
  if (!response.ok) {
    throw new Error('Error fetching blog by ID');
  }
  return response.json();
};

export const createBlogPost = async blogData => {
  const response = await fetch(`${apiUrl}/POST/blog`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(blogData),
  });

  if (!response.ok) {
    throw new Error('Error creating blog post');
  }
  return response.json();
};

export const updateBlogPost = async ({ id, blogData }) => {
  const response = await fetch(`${apiUrl}/PUT/blog/${id}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(blogData),
  });
  if (!response.ok) {
    throw new Error('Error updating blog post');
  }
  return response.json();
};

export const updateBlogMainImage = async (postId, postImageFiles) => {
  const formData = new FormData();
  for (const file of postImageFiles) {
    formData.append('post_img', file);
  }
  formData.append('post_id', postId);
  for (const [key, value] of formData.entries()) {
    console.log(key, value);
  }

  const response = await fetch(`${apiUrl}/POST/blog/update_post_img`, {
    method: 'POST',
    body: formData,
  });

  if (!response.ok) {
    throw new Error('Error updating space post img');
  }
  return response.json();
};

export const deleteBlogPost = async id => {
  const response = await fetch(`${apiUrl}/PUT/delete_blog/${id}`, {
    method: 'PUT',
  });

  if (!response.ok) {
    throw new Error('Error deleting blog post');
  }
  return response.json();
};

export const deleteBlogPostsSeveral = async blogIds => {
  const response = await fetch(`${apiUrl}/PUT/delete_blog_several`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ blogIds }),
  });

  if (!response.ok) {
    throw new Error('Error deleting multiple blog posts');
  }
  return response.json();
};

export const enabledBlogPostsSeveral = async blogIds => {
  const response = await fetch(`${apiUrl}/PUT/enabled_blog_several`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ blogIds }),
  });

  if (!response.ok) {
    throw new Error('Error enabling multiple blog posts');
  }
  return response.json();
};

export const disabledBlogPostsSeveral = async blogIds => {
  const response = await fetch(`${apiUrl}/PUT/disabled_blog_several`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ blogIds }),
  });

  if (!response.ok) {
    throw new Error('Error disabling multiple blog posts');
  }
  return response.json();
};

export const useFetchAllBlogs = () => {
  return useQuery({
    queryKey: ['blogs'],
    queryFn: fetchAllBlogs,
  });
};

export const useFetchBlogById = id => {
  return useQuery({
    queryKey: ['blog', id],
    queryFn: () => fetchBlogById(id),
    enabled: !!id,
  });
};

export const useCreateBlogPost = () => {
  return useMutation({
    mutationFn: createBlogPost,
    onSuccess: () => {
      console.log('Blog post created successfully');
    },
    onError: error => {
      console.error('Error creating blog post:', error);
    },
  });
};

export const useUpdateBlogMainImage = () => {
  return useMutation({
    mutationFn: data => updateBlogMainImage(data.postId, data.postImageFiles),
    onSuccess: () => {
      console.log('Space post img updated successfully');
    },
    onError: error => {
      console.error('Error updating blog post image:', error);
    },
  });
};

export const useUpdateBlogPost = () => {
  return useMutation({
    mutationFn: updateBlogPost,
    onSuccess: () => {
      console.log('Blog post updated successfully');
    },
    onError: error => {
      console.error('Error updating blog post:', error);
    },
  });
};

export const useDeleteBlogPost = () => {
  return useMutation({
    mutationFn: deleteBlogPost,
    onSuccess: () => {
      console.log('Blog post deleted successfully');
    },
    onError: error => {
      console.error('Error deleting blog post:', error);
    },
  });
};

export const useDeleteBlogPostsSeveral = () => {
  return useMutation({
    mutationFn: deleteBlogPostsSeveral,
    onSuccess: () => {
      console.log('Multiple blog posts deleted successfully');
    },
    onError: error => {
      console.error('Error deleting multiple blog posts:', error);
    },
  });
};

export const useEnabledBlogPostsSeveral = () => {
  return useMutation({
    mutationFn: enabledBlogPostsSeveral,
    onSuccess: () => {
      console.log('Multiple blog posts enabled successfully');
    },
    onError: error => {
      console.error('Error enabling multiple blog posts:', error);
    },
  });
};

export const useDisabledBlogPostsSeveral = () => {
  return useMutation({
    mutationFn: disabledBlogPostsSeveral,
    onSuccess: () => {
      console.log('Multiple blog posts disabled successfully');
    },
    onError: error => {
      console.error('Error disabling multiple blog posts:', error);
    },
  });
};
